module.exports = __webpack_public_path__ + "19e7378f9cc6bc631b728129dd1c8c2f.jpg";